export default {
  "content": "<g clip-path=\"url(#clip0)\" fill=\"#646974\"><path d=\"M6 12c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM6 2C3.79 2 2 3.79 2 6s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z\"/><path d=\"M9.28 10.65l1.36-1.36 4.93 4.45a1.307 1.307 0 11-1.84 1.85l-4.45-4.94z\"/></g><defs><clipPath id=\"clip0\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};